import { render, staticRenderFns } from "./EditEmergencyContact.vue?vue&type=template&id=b1d7a8bc&scoped=true"
import script from "./EditEmergencyContact.vue?vue&type=script&lang=js"
export * from "./EditEmergencyContact.vue?vue&type=script&lang=js"
import style0 from "./EditEmergencyContact.vue?vue&type=style&index=0&id=b1d7a8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d7a8bc",
  null
  
)

export default component.exports